module.exports = "/_next/static/images/ad-e2990f5d4e513a5c2d9b0c6ab1c0ff0f.svg";